<div class="zoek-panel" class:expanded>
  <slot name="title" />
  <div class="overflow-hidden" style={`height: calc(${$h}px)`}>
    <div bind:this={content} class="content">
      <slot />
    </div>
  </div>
</div>

<svelte:window on:resize={update} />

<script>
  import { tweened } from "svelte/motion";
  import { cubicOut } from "svelte/easing";
  import { tick, onMount } from "svelte";

  let content = null;
  const h = tweened(0, {
    duration: 200,
    easing: cubicOut
  });

  let expanded = false;

  export { expanded };

  $: expanded, update();

  onMount(update);

  function update() {
    if (!content) return;
    if (expanded) {
      tick().then(() => {
        const rect = content.getBoundingClientRect();
        $h = rect.height;
      });
    } else {
      $h = 0;
    }
  }
</script>

<style lang="postcss">
  .zoek-panel {
    @apply overflow-hidden;
  }

  .content {
    @apply hidden;
  }

  .expanded .content {
    @apply block;
  }
</style>
